import React from 'react';
import cn from 'classnames';
import { countryFlagStyles } from '@dealroadshow/uikit/core/components/CountryFlag';
import Role from './Role';
import { IRoleProps } from './Role/Role';
import {
  ourTeam,
  coreValues,
  POSITIONS,
  ourWorkplace,
} from './constants';
import { IconComponentType } from '@dealroadshow/uikit/core/components/Icon';

import styles from './careers.scss';
import headerStyles from '@dealroadshow/uikit/core/styles/headers.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

interface ICoreValues {
  title: string,
  description: string,
  icon: IconComponentType,
  iconClassName: string,
}

const Careers = () => {
  const renderCoreValue = (coreValue: ICoreValues, i: number) => {
    const { icon: Icon } = coreValue;
    return (
      <div
        key={ i }
        className={ styles.coreValueContainer }
      >
        <div className={ styles.coreValueIconContainer }>
          <Icon className={ cn(styles.coreValueIcon, coreValue.iconClassName) } />
        </div>
        <div className={ headerStyles.isH2 }>
          { coreValue.title }
        </div>
        <div className={ spacesStyles.mts }>
          { coreValue.description }
        </div>
      </div>
    );
  };

  const renderRole = (role: IRoleProps, i: number) => (
    <Role
      key={ i }
      { ...role }
    />
  );

  const renderTextSection = (headerText: string, paragraphText: string) => (
    <>
      <div className={ styles.header }>{ headerText }</div>
      <p className={ cn(alignStyles.alignCenter, styles.title) }>
        { paragraphText }
      </p>
    </>
  );

  return (
    <div className={ cn(styles.container, countryFlagStyles) }>
      <>
        { renderTextSection(ourTeam.title, ourTeam.description) }
        <div className={ styles.positionsHeader }>Open Positions</div>
        <div className={ styles.positionsContainer }>
          { POSITIONS.map(renderRole) }
        </div>
        { renderTextSection(ourWorkplace.title, ourWorkplace.description) }
        <div className={ styles.coreValues }>
          { coreValues.map(renderCoreValue) }
        </div>
      </>
    </div>
  );
};

export default Careers;
